// components/Pagination.jsx
import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const Pagination = ({ pagination, handlePageChange }) => {
  const renderPageButtons = () => {
    const buttons = [];
    let startPage, endPage;
    
    if (pagination.totalPages <= 5) {
      // Mostrar todas las páginas si son 5 o menos
      startPage = 1;
      endPage = pagination.totalPages;
    } else if (pagination.currentPage <= 3) {
      // Si estamos en las primeras páginas
      startPage = 1;
      endPage = 5;
    } else if (pagination.currentPage >= pagination.totalPages - 2) {
      // Si estamos en las últimas páginas
      startPage = pagination.totalPages - 4;
      endPage = pagination.totalPages;
    } else {
      // Si estamos en medio
      startPage = pagination.currentPage - 2;
      endPage = pagination.currentPage + 2;
    }
    
    for (let i = startPage; i <= endPage; i++) {
      buttons.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          className={`px-3 py-1 rounded ${
            pagination.currentPage === i 
              ? 'bg-red-600 text-white' 
              : 'bg-zinc-700 text-white hover:bg-zinc-600'
          }`}
        >
          {i}
        </button>
      );
    }
    
    return buttons;
  };

  return (
    <div className="flex justify-between items-center mt-6 px-4 py-3 bg-zinc-800 rounded-lg">
      <div className="text-sm text-gray-400">
        Mostrando <span className="font-medium text-white">
          {(pagination.currentPage - 1) * pagination.pageSize + 1}
        </span> a{' '}
        <span className="font-medium text-white">
          {Math.min(pagination.currentPage * pagination.pageSize, pagination.totalCount)}
        </span>{' '}
        de <span className="font-medium text-white">{pagination.totalCount}</span> datos
      </div>
      <div className="flex space-x-2">
        <button
          onClick={() => handlePageChange(pagination.currentPage - 1)}
          disabled={!pagination.hasPrevious}
          className="px-3 py-1 rounded bg-zinc-700 text-white hover:bg-zinc-600 disabled:opacity-50 disabled:hover:bg-zinc-700"
        >
          <FaChevronLeft />
        </button>
        
        {renderPageButtons()}
        
        <button
          onClick={() => handlePageChange(pagination.currentPage + 1)}
          disabled={!pagination.hasNext}
          className="px-3 py-1 rounded bg-zinc-700 text-white hover:bg-zinc-600 disabled:opacity-50 disabled:hover:bg-zinc-700"
        >
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
};

export default Pagination;